import { CacheableDataObject } from 'models/CacheableDataObject.jsx';
import { Users } from 'models/UserCollection.jsx';

class MatchHostCode extends CacheableDataObject {

	get player() {
		return Users.findById(this.insert_player_id);
	}

	displayValue() {
		if(this.match && this.match.ladder.has_host_code) {
			return this.code;
		}
		if(this.match.usesArenaCodes()) {
			const splitString = this.code.split('/');
			const [arenaId, password] = splitString;

			if(arenaId === undefined || password === undefined){
				return 'Unknown...';
			}
			return `Arena: ${String(arenaId).toUpperCase()} Pass: ${String(password).toUpperCase()}`
		}
		return 'Unknown...';
	}

	rawValue() {
		return this.code;
	}

	updateHostCode(updatedCode, match) {
		if(updatedCode === this || updatedCode instanceof MatchHostCode) {
			return updatedCode;
		}
		if(updatedCode instanceof MatchHostCode) {
			return updatedCode;
		}
		if(updatedCode.insert_player_id !== this.insert_player_id
			|| updatedCode.code !== this.code
			|| updatedCode.code !== this.created_at) {
			const matchHostCode = MatchHostCode.create(updatedCode);
			matchHostCode.match = match;
			return matchHostCode;
		}
		return this;
	}
}

MatchHostCode.prototype.dataLocationParsers = {};

export { MatchHostCode };